export default __webpack_public_path__ + "static/media/1.VIGILANCIA_WEB_SFS.69130249.mp4";